<template>
    <div>
        <AddUpdateViewParkDialog ref="AddUpdateViewParkDialogRef" :type="type" :parkId="parkId"
            :dialogTitle="addUpdateViewParkDialogTitle" @load="load" />
        <CompanyManagementDialog ref="CompanyManagementDialogRef" :parkId="parkId" />
        <div class="form-list">
            <div class="table-search">
                <h3>园区管理系统</h3>
                <FormQuery ref="queryForm" :data="queryParams" @submit="handleSearch" @reset="handleReset">
                </FormQuery>
                <div class="tools">
                    <el-button type="success" @click="addOrUpdateParkClick()">新增园区</el-button>
                </div>
            </div>
            <div class="table-content">
                <table-page :data="tableData" :columns="columns" :currentPage="current" :pageSize="size" :total="total"
                    :loading="loading" :border="true" @sizeChange="handleSizeChange"
                    @currentChange="handleCurrentChange" @selectionChange="handleSelection">
                    <template slot="name" slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                    </template>
                    <template slot="star" slot-scope="scope">
                        <span>{{ scope.row.star }}</span>
                    </template>
                    <template slot="updateTime" slot-scope="scope">
                        <span>{{ scope.row.updateTime }}</span>
                    </template>
                    <template slot="person" slot-scope="scope">
                        <span>{{ scope.row.person }}</span>
                    </template>
                    <template slot="operation" slot-scope="scope">
                        <el-button type="text" size="small" @click="viewParkClick(scope.row)">查看</el-button>
                        <el-button type="text" size="small" @click="addOrUpdateParkClick(scope.row.id)">修改</el-button>
                        <el-button type="text" size="small" @click="delParkClick(scope.row.id)">删除</el-button>
                        <el-button type="text" size="small" @click="openCompanyManagement(scope.row)">企业管理</el-button>
                    </template>
                </table-page>
            </div>
        </div>
    </div>
</template>
<script>
import FormQuery from "@/components/form/form-search";
import TablePage from "@/components/table/table-page";
import { parkManagementColumn } from "../tableColumn";
import { findParkPage, delParkById } from "@/api/projectManage";
import AddUpdateViewParkDialog from "./AddUpdateViewParkDialog.vue";
import CompanyManagementDialog from "./CompanyManagementDialog.vue";


export default {
    components: {
        FormQuery, TablePage, AddUpdateViewParkDialog, CompanyManagementDialog,
    },
    data() {
        return {
            columns: parkManagementColumn,
            queryParams: [
                {
                    name: "name",
                    label: "园区名：",
                    componentType: "input",
                    inputType: "",
                    placeholder: "请输入园区名",
                    width: "160px",
                },
                {
                    name: "star",
                    label: "星级：",
                    componentType: "select",
                    placeholder: "请选择",
                    width: "140px",
                    inputType: "",
                    dataOptions: [
                        { name: "1", value: 1, },
                        { name: "2", value: 2, },
                        { name: "3", value: 3, },
                        { name: "4", value: 4, },
                        { name: "5", value: 5, },
                    ],
                },
                {
                    name: "label",
                    label: "园区标签：",
                    componentType: "input",
                    placeholder: "请输入园区标签",
                    width: "180px",
                    dataOptions: [],
                }
            ],
            form: {},
            current: 1,
            size: 10,
            total: 0,
            loading: false,
            tableData: [],
            addUpdateViewParkDialogTitle: '',
            type: '',
            parkId: '',
        };
    },
    created() {
        this.load();
    },
    methods: {

        //打开企业管理弹框
        openCompanyManagement(row) {
            this.$refs.CompanyManagementDialogRef.dialogVisible = true;
            this.parkId = row.id;
        },

        //点击查看园区详情
        viewParkClick(row) {
            this.$refs.AddUpdateViewParkDialogRef.dialogVisible = true;
            this.addUpdateViewParkDialogTitle = '园区详情';
            this.type = 'view';
            this.parkId = row.id;
        },

        //新建或更新园区信息
        addOrUpdateParkClick(id) {
            this.$refs.AddUpdateViewParkDialogRef.dialogVisible = true;
            if (id) {
                this.addUpdateViewParkDialogTitle = '更新园区';
                this.type = 'update';
                this.parkId = id;
            } else {
                this.addUpdateViewParkDialogTitle = '新增园区';
                this.type = 'add';
            }
        },

        //点击删除
        delParkClick(id) {
            this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                let res = await delParkById({ id });
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: "删除成功",
                    });
                    this.load();
                }
            }).catch(() => {
            });
        },



        // 根据分页、query条件等，获取列表
        async load() {
            this.loading = true;
            let params = {
                current: this.current,
                size: this.size,
                ...this.form
            }
            let res = await findParkPage(params);
            if (res.success) {
                this.tableData = res.data;
                this.total = res.total;
            } else {
                this.$message.error("查询失败");
            }
            this.loading = false;
        },



        // 点击搜索按钮
        handleSearch(form) {
            this.form = form
            this.load();
        },
        // 搜索条件重置按钮
        handleReset() {
            this.current = 1
            this.size = 10
            this.load();
        },



        handleSelection(selects) {
            console.log(selects);
        },
        handleCurrentChange(current) {
            this.current = current
            this.load();
        },
        handleSizeChange(size) {
            this.size = size
            this.load();
        },
    },
};
</script>
<style lang="less" scoped>
.form-list {
    .table-search {
        padding: 0 30px 0 30px;

        /deep/.el-button {
            padding: 10px 20px !important;
        }

        .tools {
            margin-bottom: 18px;
            margin-top: 6px;
        }
    }

    .table-content {
        padding: 0 30px;
    }
}
</style>
